import { render, staticRenderFns } from "./report-detail.vue?vue&type=template&id=1f2735e6&"
import script from "./report-detail.vue?vue&type=script&lang=js&"
export * from "./report-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports